import { apiBlobRequest, apiRequest } from './http';
import type { ApiItemResponse, ApiListResponse } from '../types/api';

export interface AmpListQuery {
  page?: number;
  pageSize?: number;
  ampNumber?: string;
  partnerCode?: string;
  authorizationType?: 'AMPI' | 'AMPE' | 'AMI' | 'UNKNOWN' | '';
  functionCode?: 'CREATION' | 'MODIFICATION' | 'CANCELLATION' | 'UNKNOWN' | '';
  validationStatus?: string;
  processingStatus?: string;
  dateFrom?: string;
  dateTo?: string;
}

export interface AmpListItem {
  id: string;
  correlationId: string;
  ampNumber: string | null;
  partnerCode: string | null;
  authorizationType: string;
  classificationStatus: string;
  functionCode: string | null;
  validationStatus: string;
  processingStatus: string;
  processingError: string | null;
  receivedAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface AmpDetail extends AmpListItem {
  idempotencyKey: string | null;
  payloadFingerprint: string;
  rootElement: string;
  filename: string | null;
  callerId: string | null;
  sender: string | null;
  receiver: string | null;
  sourceMessageNumber: string | null;
  sourceTypeMessage: string | null;
  businessKey: string;
  rawXmlAvailable: boolean;
  rawParsedJson: Record<string, unknown> | null;
  canonicalPayload: Record<string, unknown> | null;
  normalizedJson: Record<string, unknown> | null;
  validationReport: {
    status: string;
    errors: Array<{ code: string; field: string; message: string }>;
    warnings: Array<{ code: string; field: string; message: string }>;
  } | null;
  timeline: Array<{ at: string; status: string; detail?: string }>;
}

function queryString(query: AmpListQuery): string {
  const search = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== '') search.set(key, String(value));
  });
  const serialized = search.toString();
  return serialized ? `?${serialized}` : '';
}

export async function listAmpMessages(query: AmpListQuery): Promise<ApiListResponse<AmpListItem>> {
  return apiRequest<ApiListResponse<AmpListItem>>(`/customs/amp${queryString(query)}`);
}

export async function getAmpMessage(id: string): Promise<AmpDetail> {
  const response = await apiRequest<ApiItemResponse<Omit<AmpDetail, 'normalizedJson'> & { canonicalPayload: Record<string, unknown> | null }>>(`/customs/amp/${id}`);
  return { ...response.data, normalizedJson: response.data.canonicalPayload };
}

export async function getAmpRawXml(id: string): Promise<string> {
  const { blob } = await apiBlobRequest(`/customs/amp/${id}/raw`);
  return blob.text();
}
